module.exports = __webpack_public_path__ + "static/img/shcygn1.1334c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn1.png
// module id = 370
// module chunks = 0